export default __webpack_public_path__ + "static/media/logo__project__snai.bcf7e323.png";